import React, { useState } from "react";
import UserDataForm from "./userDataForm";
import VerificationCode from "./verificationCode";

const Portfolio = ({ data = null }) => {
  const [step, setStepper] = useState(1);
  const [mfaTokenId, setMfaTokenId] = useState("");
  const handleMfaTokenId = (token) => {
    setMfaTokenId(token);
  };

  const next = () => {
    setStepper(step + 1);
  };

  const back = () => {
    setStepper(step - 1);
  };

  const componentFormatter = {
    1: (
      <UserDataForm
        data={data}
        next={next}
        handleMfaTokenId={handleMfaTokenId}
      />
    ),
    2: (
      <VerificationCode
        back={back}
        mfaTokenId={mfaTokenId}
        handleMfaTokenId={handleMfaTokenId}
      />
    ),
  };

  return <>{componentFormatter[step]}</>;
};

export default Portfolio;
